import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
    selector: 'button-renderer',
    template: `<span>{{params.key}}</span>`,
    standalone: false
})

export class FieldInputRendererComponent implements ICellRendererAngularComp{
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  constructor(){}

  getValue(){
      return this.params;
  }
  
  btnClickedHandler(evento) {
    this.params.clicked(this.params);
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
